import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { addApi } from 'shared/src/api'
import { College } from 'shared/src/api/types'
import { addNavigate } from 'shared/src/utils/addNavigate'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'

const useStyles = createUseStyles({
  headerContainer: {
    marginTop: 51,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: '#fff',
    gap: 9,
    minHeight: 267,
  },
  collegeImg: {
    width: '100%',
    height: '100%',
    filter: 'grayscale(0.9);',
    opacity: 0.8,
  },
})

interface Props {
  college: College
}

export const Header: FC<Props> = flowMax(
  addNavigate,
  addDisplayName('Header'),
  addTranslationHelpers,
  addApi,
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ classes, college }) => (
    <div className={classes.headerContainer}>
      <img
        src={college.image.full}
        alt={college.name}
        className={classes.collegeImg}
      />
    </div>
  )
)
